import { USER_TYPE } from "../constants/common";

export const getUserRoleById = (id) => {
  const userType = Object.values(USER_TYPE).find((type) => type.ID === id);
  return userType ? userType.ROLE : null;
};
